module.exports = __webpack_public_path__ + "img/folio.3ec052f.jpg";